import React from 'react';
import { Field, getIn, ErrorMessage } from 'formik';
import { Row, Col, FormGroup, Input, Label, FormFeedback } from 'reactstrap';
import * as dataSeed from '../shared/DataSeed';

export const BeneficialOwner = ({
    errors, touched, values, state, props, onValueChange, setFieldValue, handleChange, handleBlur,
    onOccupationChange,
    onPositionChange,
    onBusinessFieldChange,
    imageChange,
    occupations }) => {

    const { boPositions, boBusinessFields } = props;
    const handleCopyAddress = (isChecked) => {
        const { BeneficialOwner = {} } = values;

        if (isChecked) {
            // Validasi apakah ada data identity address
            if (!BeneficialOwner.IdentityAddressLine) {
                alert('Mohon isi alamat identitas terlebih dahulu');
                setFieldValue('copyAddress', false);
                return;
            }

            // Mapping field Identity ke Residential
            const fieldMappings = [
                { from: 'IdentityAddressLine', to: 'ResidentialAddressLine', defaultValue: '' },
                { from: 'IdentityRT', to: 'ResidentialRT', defaultValue: '' },
                { from: 'IdentityRW', to: 'ResidentialRW', defaultValue: '' },
                { from: 'IdentityVillage', to: 'ResidentialVillage', defaultValue: '' },
                { from: 'IdentitySubDistrict', to: 'ResidentialSubDistrict', defaultValue: '' },
                { from: 'IdentityCityId', to: 'ResidentialCityId', defaultValue: null },
                { from: 'IdentityCity', to: 'ResidentialCity', defaultValue: null },
                { from: 'IdentityProvinceId', to: 'ResidentialProvinceId', defaultValue: null },
                { from: 'IdentityProvince', to: 'ResidentialProvince', defaultValue: null },
                { from: 'IdentityPostalCode', to: 'ResidentialPostalCode', defaultValue: null }
            ];

            // Copy semua field
            fieldMappings.forEach(({ from, to, defaultValue }) => {
                const value = BeneficialOwner[from] !== undefined ? BeneficialOwner[from] : defaultValue;
                setFieldValue(`BeneficialOwner.${to}`, value);
            });
            setFieldValue('BeneficialOwner.IdentityAddressResidential', true);
        } else {
            // Clear semua residential fields
            const residentialFields = [
                'ResidentialAddressLine',
                'ResidentialRT',
                'ResidentialRW',
                'ResidentialVillage',
                'ResidentialSubDistrict',
                'ResidentialCityId',
                'ResidentialCity',
                'ResidentialProvinceId',
                'ResidentialProvince',
                'ResidentialPostalCode'
            ];

            residentialFields.forEach(field => {
                const defaultValue = field.includes('Id') || field.includes('Code') ? null : '';
                setFieldValue(`BeneficialOwner.${field}`, defaultValue);
            });
            setFieldValue('BeneficialOwner.IdentityAddressResidential', false);
        }
    };

    return (<React.Fragment>
        <legend>Data Beneficial Owner</legend>
        <Row>
            <Col md="12">
                <div class="alert alert-primary" role="alert">
                    Silakan mengisi data berikut dengan data beneficial owner, bukan data Anda
                </div>
            </Col>
        </Row>
        <Row>
            <Col md="6">

                <FormGroup>
                    <Label>Nama Lengkap<span className="text-danger">*</span> </Label>
                    <Input tag={Field} type="text" name="BeneficialOwner.Name" bsSize="sm"
                        invalid={!!(getIn(errors, 'BeneficialOwner.Name') && getIn(touched, 'BeneficialOwner.Name'))}
                    />
                    <ErrorMessage
                        name="BeneficialOwner.Name"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>
            <Col md="3">
                <FormGroup>
                    <Label>Kartu Identitas<span className="text-danger">*</span> </Label>
                    <Field component="select" name="BeneficialOwner.IdentityType"
                        className={
                            getIn(errors, 'BeneficialOwner.IdentityType') && getIn(touched, 'BeneficialOwner.IdentityType')
                                ? 'is-invalid form-control form-control-sm'
                                : 'form-control form-control-sm'
                        }
                    >
                        <option value="">-- Pilih --</option>
                        <option value="KTP">KTP</option>
                        <option value="Paspor">Paspor</option>
                    </Field>
                    <ErrorMessage
                        name="BeneficialOwner.IdentityType"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>
            <Col md="3">
                <FormGroup>
                    <Label>Nomor Identitas<span className="text-danger">*</span> </Label>
                    <Input tag={Field} type="text" name="BeneficialOwner.IdentityNumber" bsSize="sm"
                        invalid={!!(getIn(errors, 'BeneficialOwner.IdentityNumber') && getIn(touched, 'BeneficialOwner.IdentityNumber'))}
                    />
                    <ErrorMessage
                        name="BeneficialOwner.IdentityNumber"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="6">
                <FormGroup>
                    <Label>Jenis Kelamin<span className="text-danger">*</span></Label>
                    <Field className={
                        getIn(errors, 'BeneficialOwner.GenderId') && getIn(touched, 'BeneficialOwner.GenderId')
                            ? 'is-invalid form-control form-control-sm'
                            : 'form-control form-control-sm'
                    }
                        component="select" name="BeneficialOwner.GenderId"
                        validate={errors.gender && touched.gender}>
                        <option value="">-- Pilih --</option>
                        {dataSeed.genders.map((gender, index) =>
                            <option value={gender.id} key={index}>{gender.name}</option>
                        )}
                    </Field>
                    <ErrorMessage
                        name="BeneficialOwner.GenderId"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>
            <Col md="3">
                <FormGroup>
                    <Label>Kewarganegaraan<span className="text-danger">*</span> </Label>
                    <Field component="select" name="BeneficialOwner.Citizenship"
                        className={
                            getIn(errors, 'BeneficialOwner.Citizenship') && getIn(touched, 'BeneficialOwner.Citizenship')
                                ? 'is-invalid form-control form-control-sm'
                                : 'form-control form-control-sm'
                        }
                    >
                        <option value="">-- Pilih --</option>
                        <option value="WNI">WNI</option>
                    </Field>
                    <ErrorMessage
                        name="BeneficialOwner.Citizenship"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="4">
                <FormGroup>
                    <Label>Tanggal Lahir<span className="text-danger">*</span></Label>
                    <Input tag={Field} type="date" name="BeneficialOwner.BirthDate" bsSize="sm"
                        invalid={!!(getIn(errors, 'BeneficialOwner.BirthDate') && getIn(touched, 'BeneficialOwner.BirthDate'))}
                    />
                    <ErrorMessage
                        name="BeneficialOwner.BirthDate"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>
            <Col md="4">
                <FormGroup>
                    <Label>Tempat Lahir<span className="text-danger">*</span></Label>
                    <Input tag={Field} type="text" name="BeneficialOwner.BirthPlace" bsSize="sm"
                        invalid={!!(getIn(errors, 'BeneficialOwner.BirthPlace') && getIn(touched, 'BeneficialOwner.BirthPlace'))}
                    />
                    <ErrorMessage
                        name="BeneficialOwner.BirthPlace"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>
            <Col md="4">
                <FormGroup>
                    <Label>Sumber Penghasilan</Label>
                    <Field component="select" name="BeneficialOwner.IncomeSourceId"
                        className={
                            getIn(errors, 'BeneficialOwner.IncomeSourceId') && getIn(touched, 'BeneficialOwner.IncomeSourceId')
                                ? 'is-invalid form-control form-control-sm'
                                : 'form-control form-control-sm'
                        }
                    >
                        <option value="">-- Pilih --</option>
                        {dataSeed.incomeSourcesBeneficialOwner.map((data, index) =>
                            <option value={data.id} key={index}>{data.name}</option>
                        )}
                    </Field>
                    <ErrorMessage
                        name="BeneficialOwner.IncomeSourceId"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>
            <Col md="4">
                <FormGroup>
                    <Label>Status Pernikahan <span className="text-danger">*</span></Label>
                    <Field component="select" name="BeneficialOwner.MaritalStatusId" id="MaritalStatus"
                        className={
                            getIn(errors, 'BeneficialOwner.MaritalStatusId') && getIn(touched, 'BeneficialOwner.MaritalStatusId')
                                ? 'is-invalid form-control form-control-sm'
                                : 'form-control form-control-sm'
                        }
                    >
                        <option value="">-- Pilih --</option>
                        {dataSeed.maritalStatuses.map((data, index) =>
                            <option value={data.id} key={index}>{data.name}</option>
                        )}
                    </Field>
                    <ErrorMessage
                        name="BeneficialOwner.MaritalStatusId"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>
            <Col md="4">
                <FormGroup>
                    <Label>Penghasilan / Tahun<span className="text-danger">*</span></Label>
                    <Field component="select" name="BeneficialOwner.IncomePerAnnumBCAId"
                        className={
                            getIn(errors, 'BeneficialOwner.IncomePerAnnumBCAId') && getIn(touched, 'BeneficialOwner.IncomePerAnnumBCAId')
                                ? 'is-invalid form-control form-control-sm'
                                : 'form-control form-control-sm'
                        }
                    >
                        <option value="">-- Pilih --</option>
                        {dataSeed.incomePerAnnumBCAs.map((data, index) =>
                            <option value={data.id} key={index}>{data.name}</option>
                        )}
                    </Field>
                    <ErrorMessage
                        name="BeneficialOwner.IncomePerAnnumBCAId"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="4">
                <FormGroup>
                    <Label>Pekerjaan</Label>
                    <Field component="select" name="BeneficialOwner.OccupationId"
                        onChange={(e) => onOccupationChange(e, setFieldValue)}
                        className={
                            getIn(errors, 'BeneficialOwner.OccupationId') && getIn(touched, 'BeneficialOwner.OccupationId')
                                ? 'is-invalid form-control form-control-sm'
                                : 'form-control form-control-sm'
                        }
                    >
                        <option value="">-- Pilih --</option>
                        {occupations
                            .filter(occupation => !occupation.Description.toLowerCase().includes('ibu rumah tangga') && !occupation.Description.toLowerCase().includes('pelajar/mahasiswa'))
                            .map((occupation, i) =>
                                <option key={i} value={occupation.Id}>{occupation.Description}</option>
                            )}
                    </Field>
                    <ErrorMessage
                        name="BeneficialOwner.OccupationId"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>

            {values.BeneficialOwner ?
                (values.BeneficialOwner.OccupationId === "12") ?
                    <Col md="4">
                        <FormGroup>
                            <Label>Pekerjaan Lainnya</Label>
                            <Input tag={Field} type="text" name="BeneficialOwner.OccupationOthers" bsSize="sm"
                                invalid={!!(getIn(errors, 'BeneficialOwner.OccupationOthers') && getIn(touched, 'BeneficialOwner.OccupationOthers'))}
                                disabled={values.BeneficialOwner.OccupationId !== "12"}
                            />
                            <ErrorMessage
                                name="BeneficialOwner.OccupationOthers"
                                component="div"
                                className="invalid-feedback"
                            />
                        </FormGroup>
                    </Col>
                    : null
                : null}

            <Col md="4">
                <FormGroup>
                    <Label>Posisi<span className="text-danger">*</span></Label>
                    <Field component="select" name="BeneficialOwner.PositionId"
                        onChange={(e) => onPositionChange(e, values.OccupationId, setFieldValue, values)}
                        className={
                            getIn(errors, 'BeneficialOwner.PositionId') && getIn(touched, 'BeneficialOwner.PositionId')
                                ? 'is-invalid form-control form-control-sm'
                                : 'form-control form-control-sm'
                        }
                    >
                        <option value="">-- Pilih --</option>
                        {boPositions.sort((a, b) => b.Id - a.Id).map((position, i) =>
                            <option key={i} value={position.Id}>{position.Description}</option>
                        )}
                    </Field>
                    <ErrorMessage
                        name="BeneficialOwner.PositionId"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>

            {values.BeneficialOwner ?
                (values.BeneficialOwner.PositionId === "41") ?
                    <Col md="4">
                        <FormGroup>
                            <Label>Posisi Lainnya<span className="text-danger">*</span></Label>
                            <Input tag={Field} type="text" name="BeneficialOwner.Position" bsSize="sm"
                                invalid={!!(getIn(errors, 'BeneficialOwner.Position') && getIn(touched, 'BeneficialOwner.Position'))}
                            />
                            <ErrorMessage
                                name="BeneficialOwner.Position"
                                component="div"
                                className="invalid-feedback"
                            />
                        </FormGroup>
                    </Col>
                    : null
                : null}

            <Col md="4">
                <FormGroup>
                    <Label>Bidang Usaha<span className="text-danger">*</span></Label>
                    <Field component="select" name="BeneficialOwner.BusinessFieldId"
                        className={
                            getIn(errors, 'BeneficialOwner.BusinessFieldId') && getIn(touched, 'BeneficialOwner.BusinessFieldId')
                                ? 'is-invalid form-control form-control-sm'
                                : 'form-control form-control-sm'
                        }
                        onChange={(e) => onBusinessFieldChange(e, setFieldValue, values)}
                    >
                        <option value="">-- Pilih --</option>
                        {boBusinessFields.sort((a, b) => b.Id - a.Id).map((businessField, i) =>
                            <option key={i} value={businessField.Id}>{businessField.Description}</option>
                        )}
                    </Field>
                    <ErrorMessage
                        name="BeneficialOwner.BusinessFieldId"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>

            {values.BeneficialOwner ?
                (values.BeneficialOwner.BusinessFieldId === "25") ?
                    <Col md="4">
                        <FormGroup>
                            <Label>Bidang Usaha Lainnya<span className="text-danger">*</span></Label>
                            <Input tag={Field} type="text" name="BeneficialOwner.BusinessField" bsSize="sm"
                                invalid={!!(getIn(errors, 'BeneficialOwner.BusinessField') && getIn(touched, 'BeneficialOwner.BusinessField'))}
                            />
                            <ErrorMessage
                                name="BeneficialOwner.BusinessField"
                                component="div"
                                className="invalid-feedback"
                            />
                        </FormGroup>
                    </Col>
                    : null
                : null}

            <Col md="4">
                <FormGroup>
                    <Label>Nama Perusahaan<span className="text-danger">*</span></Label>
                    <Input tag={Field} type="text" name="BeneficialOwner.CompanyName" bsSize="sm"
                        invalid={!!(getIn(errors, 'BeneficialOwner.CompanyName') && getIn(touched, 'BeneficialOwner.CompanyName'))}
                    >
                    </Input>
                    <ErrorMessage
                        name="BeneficialOwner.CompanyName"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>

        </Row>
        <Row>
            <Col md="12">
                <FormGroup>
                    <Label>Alamat Sesuai KTP<span className="text-danger">*</span></Label>
                    <Input tag={Field} name="BeneficialOwner.IdentityAddressLine" bsSize="sm" maxLength={100}
                        invalid={!!(getIn(errors, 'BeneficialOwner.IdentityAddressLine') && getIn(touched, 'BeneficialOwner.IdentityAddressLine'))}
                    />
                    <ErrorMessage
                        name="BeneficialOwner.IdentityAddressLine"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col xs="6">
                <FormGroup>
                    <Label>RT<span className="text-danger">*</span></Label>
                    <Input tag={Field} name="BeneficialOwner.IdentityRT" type="tel" bsSize="sm" maxLength="3"
                        invalid={!!(getIn(errors, 'BeneficialOwner.IdentityRT') && getIn(touched, 'BeneficialOwner.IdentityRT'))}
                    />
                    <ErrorMessage
                        name="BeneficialOwner.IdentityRT"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>
            <Col xs="6">
                <FormGroup>
                    <Label>RW<span className="text-danger">*</span></Label>
                    <Input tag={Field} name="BeneficialOwner.IdentityRW" type="tel" bsSize="sm" maxLength="3"
                        invalid={!!(getIn(errors, 'BeneficialOwner.IdentityRW') && getIn(touched, 'BeneficialOwner.IdentityRW'))}
                    />
                    <ErrorMessage
                        name="BeneficialOwner.IdentityRW"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Provinsi<span className="text-danger">*</span> </Label>
                    <Field component="select" name="BeneficialOwner.IdentityProvinceId"
                        className={
                            getIn(errors, 'BeneficialOwner.IdentityProvinceId') && getIn(touched, 'BeneficialOwner.ProvinceId')
                                ? 'is-invalid form-control form-control-sm'
                                : 'form-control form-control-sm'
                        }
                        onChange={(e) => onValueChange(e, setFieldValue)}
                    >
                        <option value="">-- Pilih --</option>
                        {props.provinces.map((province, i) =>
                            <option key={i} value={province.Id}>{province.Name}</option>
                        )}
                    </Field>
                    <ErrorMessage
                        name="BeneficialOwner.ProvinceId"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>
            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Kota<span className="text-danger">*</span></Label>
                    <Field component="select" name="BeneficialOwner.IdentityCityId"
                        className={
                            getIn(errors, 'BeneficialOwner.IdentityCityId') && getIn(touched, 'BeneficialOwner.IdentityCityId')
                                ? 'is-invalid form-control form-control-sm'
                                : 'form-control form-control-sm'
                        }
                        onChange={(e) => onValueChange(e, setFieldValue)}
                    >
                        <option value="">-- Pilih --</option>
                        {props.boIdentityCities ? props.boIdentityCities.map((city, i) =>
                            <option key={i} value={city.Id}>{city.Name}</option>
                        ) : null}
                    </Field>
                    <ErrorMessage
                        name="BeneficialOwner.IdentityCityId"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>


            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Kecamatan<span className="text-danger">*</span></Label>
                    <Field component="select" name="BeneficialOwner.IdentitySubDistrict"
                        className={
                            getIn(errors, 'BeneficialOwner.IdentitySubDistrict') && getIn(touched, 'BeneficialOwner.IdentitySubDistrict')
                                ? 'is-invalid form-control form-control-sm'
                                : 'form-control form-control-sm'
                        }
                        onChange={(e) => onValueChange(e, setFieldValue)}
                    >
                        <option value="">-- Pilih --</option>
                        {props.boIdentityDistricts ? props.boIdentityDistricts.map((item, i) =>
                            <option key={i} value={item.Name}>{item.Name}</option>
                        ) : null}
                    </Field>
                    <ErrorMessage
                        name="BeneficialOwner.IdentitySubDistrict"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>
            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Kelurahan<span className="text-danger">*</span></Label>
                    <Field component="select" name="BeneficialOwner.IdentityVillage"
                        className={
                            getIn(errors, 'BeneficialOwner.IdentityVillage') && getIn(touched, 'BeneficialOwner.IdentityVillage')
                                ? 'is-invalid form-control form-control-sm'
                                : 'form-control form-control-sm'
                        }
                        onChange={(e) => onValueChange(e, setFieldValue)}
                    >
                        <option value="">-- Pilih --</option>
                        {props.boIdentitySubDistricts ? props.boIdentitySubDistricts.map((item, i) =>
                            <option key={i} value={item.Name}>{item.Name}</option>
                        ) : null}
                    </Field>
                    <ErrorMessage
                        name="BeneficialOwner.IdentitySubDistrict"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>

            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Negara<span className="text-danger">*</span></Label>
                    <Field component="select" name="Country" disabled={true} tag={Field}
                        className={errors.Country && touched.Country ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                    >
                        <option value="">-- Pilih --</option>
                        <option value="ID">Indonesia</option>
                    </Field>
                    {errors.Country && touched.Country ? (
                        <FormFeedback>{errors.Country}</FormFeedback>
                    ) : null}
                </FormGroup>
            </Col>
            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Kode Pos<span className="text-danger">*</span></Label>
                    <Input tag={Field} type="tel" maxLength="5" name="BeneficialOwner.IdentityPostalCode" bsSize="sm"
                        invalid={!!(getIn(errors, 'BeneficialOwner.IdentityPostalCode') && getIn(touched, 'BeneficialOwner.IdentityPostalCode'))}
                    />
                    <ErrorMessage
                        name="BeneficialOwner.IdentityPostalCode"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="12">
                <Field name="IdentityAddressResidential">
                    {({ field }) => (
                        <label>
                            <input
                                type="checkbox"
                                checked={values.BeneficialOwner.IdentityAddressResidential || false}
                                onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    setFieldValue('BeneficialOwner.IdentityAddressResidential', isChecked);
                                    //handleCopyAddress(isChecked);
                                }}
                            />
                            Alamat tempat tinggal sama dengan alamat identitas
                        </label>
                    )}
                </Field>
            </Col>
        </Row>
        {values.BeneficialOwner && (
            !values.BeneficialOwner.IdentityAddressResidential && (
                <React.Fragment>
                    <Row>

                        <Col md="12">
                            <FormGroup>
                                <Label>Alamat Tempat Tinggal<span className="text-danger">*</span></Label>
                                <Input tag={Field} name="BeneficialOwner.ResidentialAddressLine" bsSize="sm" maxLength={100}
                                    invalid={!!(getIn(errors, 'BeneficialOwner.ResidentialAddressLine') && getIn(touched, 'BeneficialOwner.ResidentialAddressLine'))}
                                />
                                <ErrorMessage
                                    name="BeneficialOwner.ResidentialAddressLine"
                                    component="div"
                                    className="invalid-feedback"
                                />
                            </FormGroup>
                        </Col>

                        <Col xs="6">
                            <FormGroup>
                                <Label>RT<span className="text-danger">*</span></Label>
                                <Input tag={Field} name="BeneficialOwner.ResidentialRT" type="tel" bsSize="sm" maxLength="3"
                                    invalid={!!(getIn(errors, 'BeneficialOwner.ResidentialRT') && getIn(touched, 'BeneficialOwner.ResidentialRT'))}
                                />
                                <ErrorMessage
                                    name="BeneficialOwner.ResidentialRT"
                                    component="div"
                                    className="invalid-feedback"
                                />
                            </FormGroup>
                        </Col>
                        <Col xs="6">
                            <FormGroup>
                                <Label>RW<span className="text-danger">*</span></Label>
                                <Input tag={Field} name="BeneficialOwner.ResidentialRW" type="tel" bsSize="sm" maxLength="3"
                                    invalid={!!(getIn(errors, 'BeneficialOwner.ResidentialRW') && getIn(touched, 'BeneficialOwner.ResidentialRW'))}
                                />
                                <ErrorMessage
                                    name="BeneficialOwner.ResidentialRW"
                                    component="div"
                                    className="invalid-feedback"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4" xs="6">
                            <FormGroup>
                                <Label>Provinsi<span className="text-danger">*</span> </Label>
                                <Field component="select" name="BeneficialOwner.ResidentialProvinceId"
                                    className={
                                        getIn(errors, 'BeneficialOwner.ResidentialProvinceId') && getIn(touched, 'BeneficialOwner.ProvinceId')
                                            ? 'is-invalid form-control form-control-sm'
                                            : 'form-control form-control-sm'
                                    }
                                    onChange={(e) => onValueChange(e, setFieldValue)}
                                >
                                    <option value="">-- Pilih --</option>
                                    {props.provinces.map((province, i) =>
                                        <option key={i} value={province.Id}>{province.Name}</option>
                                    )}
                                </Field>
                                <ErrorMessage
                                    name="BeneficialOwner.ProvinceId"
                                    component="div"
                                    className="invalid-feedback"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4" xs="6">
                            <FormGroup>
                                <Label>Kota<span className="text-danger">*</span></Label>
                                <Field component="select" name="BeneficialOwner.ResidentialCityId"
                                    className={
                                        getIn(errors, 'BeneficialOwner.ResidentialCityId') && getIn(touched, 'BeneficialOwner.ResidentialCityId')
                                            ? 'is-invalid form-control form-control-sm'
                                            : 'form-control form-control-sm'
                                    }
                                    onChange={(e) => onValueChange(e, setFieldValue)}
                                >
                                    <option value="">-- Pilih --</option>
                                    {props.boResidentialCities ? props.boResidentialCities.map((city, i) =>
                                        <option key={i} value={city.Id}>{city.Name}</option>
                                    ) : null}
                                </Field>
                                <ErrorMessage
                                    name="BeneficialOwner.ResidentialCityId"
                                    component="div"
                                    className="invalid-feedback"
                                />
                            </FormGroup>
                        </Col>


                        <Col md="4" xs="6">
                            <FormGroup>
                                <Label>Kecamatan<span className="text-danger">*</span></Label>
                                <Field component="select" name="BeneficialOwner.ResidentialSubDistrict"
                                    className={
                                        getIn(errors, 'BeneficialOwner.ResidentialSubDistrict') && getIn(touched, 'BeneficialOwner.ResidentialSubDistrict')
                                            ? 'is-invalid form-control form-control-sm'
                                            : 'form-control form-control-sm'
                                    }
                                    onChange={(e) => onValueChange(e, setFieldValue)}
                                >
                                    <option value="">-- Pilih --</option>
                                    {props.boResidentialDistricts ? props.boResidentialDistricts.map((item, i) =>
                                        <option key={i} value={item.Name}>{item.Name}</option>
                                    ) : null}
                                </Field>
                                <ErrorMessage
                                    name="BeneficialOwner.ResidentialSubDistrict"
                                    component="div"
                                    className="invalid-feedback"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4" xs="6">
                            <FormGroup>
                                <Label>Kelurahan<span className="text-danger">*</span></Label>
                                <Field component="select" name="BeneficialOwner.ResidentialVillage"
                                    className={
                                        getIn(errors, 'BeneficialOwner.ResidentialVillage') && getIn(touched, 'BeneficialOwner.ResidentialVillage')
                                            ? 'is-invalid form-control form-control-sm'
                                            : 'form-control form-control-sm'
                                    }
                                    onChange={(e) => onValueChange(e, setFieldValue)}
                                >
                                    <option value="">-- Pilih --</option>
                                    {props.boResidentialSubDistricts ? props.boResidentialSubDistricts.map((item, i) =>
                                        <option key={i} value={item.Name}>{item.Name}</option>
                                    ) : null}
                                </Field>
                                <ErrorMessage
                                    name="BeneficialOwner.ResidentialSubDistrict"
                                    component="div"
                                    className="invalid-feedback"
                                />
                            </FormGroup>
                        </Col>

                        <Col md="4" xs="6">
                            <FormGroup>
                                <Label>Negara<span className="text-danger">*</span></Label>
                                <Field component="select" name="Country" disabled={true} tag={Field}
                                    className={errors.Country && touched.Country ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                                >
                                    <option value="">-- Pilih --</option>
                                    <option value="ID">Indonesia</option>
                                </Field>
                                {errors.Country && touched.Country ? (
                                    <FormFeedback>{errors.Country}</FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Col>
                        <Col md="4" xs="6">
                            <FormGroup>
                                <Label>Kode Pos<span className="text-danger">*</span></Label>
                                <Input tag={Field} type="tel" maxLength="5" name="BeneficialOwner.ResidentialPostalCode" bsSize="sm"
                                    invalid={!!(getIn(errors, 'BeneficialOwner.ResidentialPostalCode') && getIn(touched, 'BeneficialOwner.ResidentialPostalCode'))}
                                />
                                <ErrorMessage
                                    name="BeneficialOwner.ResidentialPostalCode"
                                    component="div"
                                    className="invalid-feedback"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </React.Fragment>
            )
        )
        }

        <Row>
            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Hubungan<span className="text-danger">*</span></Label>
                    <Field component="select" name="BeneficialOwner.Relationship" tag={Field}
                        className={
                            getIn(errors, 'BeneficialOwner.Relationship') && getIn(touched, 'BeneficialOwner.Relationship')
                                ? 'is-invalid form-control form-control-sm'
                                : 'form-control form-control-sm'
                        }
                    >
                        <option value="">-- Pilih --</option>
                        <option value="ANAK">Anak</option>
                        <option value="ORANG TUA">Orang Tua</option>
                        <option value="SUAMI/ISTRI">Suami/Istri</option>
                        <option value="SAUDARA KELUARGA">Saudara Keluarga</option>
                        <option value="KAKAK/ADIK">Kakak/Adik</option>
                    </Field>
                    <ErrorMessage
                        name="BeneficialOwner.Relationship"
                        component="div"
                        className="invalid-feedback"
                    />
                </FormGroup>
            </Col>

            {/*<Col md="4" xs="6">*/}
            {/*    <FormGroup>*/}
            {/*        <Label>Jenis Dokumen<span className="text-danger">*</span></Label>*/}
            {/*        <Field component="select" name="BeneficialOwner.RelationDocumentType" tag={Field}*/}
            {/*            className={*/}
            {/*                getIn(errors, 'BeneficialOwner.RelationDocumentType') && getIn(touched, 'BeneficialOwner.RelationDocumentType')*/}
            {/*                    ? 'is-invalid form-control form-control-sm'*/}
            {/*                    : 'form-control form-control-sm'*/}
            {/*            }*/}
            {/*        >*/}
            {/*            <option value="">-- Pilih --</option>*/}
            {/*            <option value="AKTA KELAHIRAN">AKTA KELAHIRAN</option>*/}
            {/*            <option value="KARTU KELUARGA">KARTU KELUARGA</option>*/}
            {/*            <option value="AKTA PERNIKAHAN">AKTA PERNIKAHAN</option>*/}
            {/*        </Field>*/}
            {/*        <ErrorMessage*/}
            {/*            name="BeneficialOwner.RelationDocumentType"*/}
            {/*            component="div"*/}
            {/*            className="invalid-feedback"*/}
            {/*        />*/}
            {/*    </FormGroup>*/}
            {/*</Col>*/}

            {values.BeneficialOwner.Relationship !== '' && values.BeneficialOwner.Relationship !== null ?
                <Col md="6" xs="6" >
                    <FormGroup>
                        {values.BeneficialOwner.Relationship == 'ANAK' || values.BeneficialOwner.Relationship == 'ORANG TUA' ?
                            <Label>Upload Dokumen Hubungan Relasi Keluarga (Akta Lahir atau Kartu Keluarga)<span className="text-danger">*</span></Label>
                            : null
                        }
                        {values.BeneficialOwner.Relationship == 'SUAMI/ISTRI' ?
                            <Label>Upload Dokumen Hubungan Relasi Keluarga (Akta Pernikahan atau Kartu Keluarga)<span className="text-danger">*</span></Label>
                            : null
                        }
                        {values.BeneficialOwner.Relationship == 'SAUDARA KELUARGA' || values.BeneficialOwner.Relationship == 'KAKAK/ADIK' ?
                            <Label>Upload Dokumen Hubungan Relasi Keluarga (Kartu Keluarga)<span className="text-danger">*</span></Label>
                            : null
                        }

                        <Input type="file" accept="image/*" id="PhotoDokumenHubunganBeneficialOwner" name="PhotoDokumenHubunganBeneficialOwner"
                            onChange={(e) => imageChange(e, setFieldValue)}
                        />
                        {errors.PhotoDokumenHubunganBeneficialOwner && touched.PhotoSePhotoDokumenHubunganBeneficialOwnerlfieKTP ? (
                            <FormFeedback>{errors.PhotoDokumenHubunganBeneficialOwner}</FormFeedback>
                        ) : null}

                        {values.PhotoDokumenHubunganBeneficialOwner &&
                            <img src={values.PhotoDokumenHubunganBeneficialOwner} alt="Captured" className="img-fluid" />
                        }
                    </FormGroup>
                </Col>
                : null}
        </Row>
    </React.Fragment>
    );
};


// WEBPACK FOOTER //
// ./src/components/BeneficialOwner.js